import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_DOCTOR_LEAVES,
  DOCTOR_LEAVE_SUBMIT_FORM,
  DOCTOR_LEAVE_EDIT_SUBMIT_FORM,
  DOCTOR_LEAVE_DELETE,
} from "constants/doctorLeave.constants";
import axios from "axios";
import { getDoctorLeaveSuccess, doctorLeaveActionSuccess } from "actions/doctorLeave.action";
import { showErrors, stopLoader, setNotification } from "actions/general.action";
import moment from "moment";

// get doctor leaves
const fetchDoctorLeavesRequest = async (page) => {
  let link = "/api/v1/super_admin/doctor_leaves";
  if (page) {
    link = `/api/v1/super_admin/doctor_leaves?page=${page}`;
  }
  return axios.get(link);
};

function* fetchDoctorLeaves({ page }) {
  try {
    const result = yield call(fetchDoctorLeavesRequest, page);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getDoctorLeaveSuccess(result.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const createDoctorLeaveRequest = async (new_doctor_leaves_data) => {
  const { doctor_id, start_date, end_date, remark } = new_doctor_leaves_data;
  const doctorLeaveObject = {
    doctor_id: parseInt(doctor_id),
    start_time_date: moment(start_date).format("YYYY-MM-DDTHH:mm:ss"),
    end_time_date: moment(end_date).format("YYYY-MM-DDTHH:mm:ss"),
    remark: remark,
    active_status: 1,
  };
  return axios.post("/api/v1/super_admin/doctor_leaves", doctorLeaveObject);
};

// create doctor leaves
function* createDoctorLeaves({ new_doctor_leaves_data }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  };
  try {
    const result = yield call(createDoctorLeaveRequest, new_doctor_leaves_data);
    if (result.message) {
      notification.status = "error";
      notification.message = result.message;
    } else {
      const resultShiftCategories = yield call(fetchDoctorLeavesRequest);
      if (resultShiftCategories.message) {
        notification.status = "error";
        notification.message = resultShiftCategories.message;
      } else {
        notification.status = "success";
        notification.message = "Doctor Leave Created";
        yield all([put(doctorLeaveActionSuccess(resultShiftCategories.data))]);
      }
    }
    yield put(stopLoader());
    yield put(setNotification(notification));
  } catch (error) {
    notification.status = "error";
    notification.message = error.message;
    yield put(stopLoader());
    yield put(setNotification(notification));
  }
}

const updateDoctorLeaveRequest = async (doctor_leave_data) => {
  const { id, doctor_id, start_date, end_date, remark } = doctor_leave_data;
  const doctorLeaveObject = {
    doctor_id: parseInt(doctor_id),
    start_time_date: moment(start_date).format("YYYY-MM-DDTHH:mm:ss"),
    end_time_date: moment(end_date).format("YYYY-MM-DDTHH:mm:ss"),
    remark: remark,
    active_status: 1,
  };
  return axios.put("/api/v1/super_admin/doctor_leaves/" + id, doctorLeaveObject);
};

// update doctor leaves
function* updateDoctorLeaves({ doctor_leave_data, page }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  };
  try {
    const reuslt = yield call(updateDoctorLeaveRequest, doctor_leave_data);
    if (reuslt.message) {
      notification.status = "error";
      notification.message = reuslt.message;
    } else {
      const resultShiftCategories = yield call(fetchDoctorLeavesRequest, page);
      if (resultShiftCategories.message) {
        notification.status = "error";
        notification.message = resultShiftCategories.message;
      } else {
        notification.status = "success";
        notification.message = "Doctor Leave Updated";
        yield all([put(doctorLeaveActionSuccess(resultShiftCategories.data))]);
      }
    }
    yield put(stopLoader());
    yield put(setNotification(notification));
  } catch (error) {
    notification.status = "error";
    notification.message = error.message;
    yield put(stopLoader());
    yield put(setNotification(notification));
  }
}

const deleteDoctorLeaveRequest = async (id) => {
  return axios({
    method: "delete",
    url: "/api/v1/super_admin/doctor_leaves/" + id,
    headers: {
      'Content-Type': 'text/plain'
    },
    data: "",
  });
};

// // Delete doctor leaves
function* deleteDoctorLeaves({ doctor_leave_id }) {
  try {
    const reuslt = yield call(deleteDoctorLeaveRequest, doctor_leave_id);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      const resultShiftCategories = yield call(fetchDoctorLeavesRequest);
      if (resultShiftCategories.message) {
        yield put(showErrors(resultShiftCategories.message));
      } else {
        yield all([
          put(doctorLeaveActionSuccess(resultShiftCategories.data)),
          put(stopLoader("Doctor Leave Deleted")),
        ]);
      }
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

export function* forkFetchDoctorLeaves() {
  yield takeEvery(FETCH_DOCTOR_LEAVES, fetchDoctorLeaves);
}

export function* forkCreateDoctorLeaves() {
  yield takeEvery(DOCTOR_LEAVE_SUBMIT_FORM, createDoctorLeaves);
}

export function* forkUpdateDoctorLeaves() {
  yield takeEvery(DOCTOR_LEAVE_EDIT_SUBMIT_FORM, updateDoctorLeaves);
}

export function* forkDeleteDoctorLeaves() {
  yield takeEvery(DOCTOR_LEAVE_DELETE, deleteDoctorLeaves);
}

export default function* rootSaga() {
  yield all([
    fork(forkFetchDoctorLeaves),
    fork(forkCreateDoctorLeaves),
    fork(forkUpdateDoctorLeaves),
    fork(forkDeleteDoctorLeaves),
  ]);
}
